import Chat from './../../components/chats/container/Chat';
import { useDispatch } from 'react-redux';
import { setToken } from '@/store/slices/chatSlice';
import Cookies from 'universal-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const ChatRoom = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    useEffect(() => {
        const cookies = new Cookies();
        const queryToken = router.query?.token;

        if (queryToken) {
            dispatch(setToken({
                token: queryToken,
                user_type: 'buyer'
            }));
            return;
        }

        const _token = cookies.get('token');
        if (_token) {
            dispatch(setToken({
                token: _token,
                user_type: 'buyer'
            }));
        }

        const handleMessage = (event: MessageEvent) => {
            try {
                const data = JSON.parse(event.data);
                if (data.token) {
                    dispatch(setToken({
                        token: data.token,
                        user_type: 'buyer'
                    }));
                }
            } catch (e) {
                // Ignore invalid messages
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [router.query]);

    return <Chat/>;
};

export default ChatRoom;